import React from 'react'

function Service({image, text, isSelected, onClick}) {
    return (
        <div className="service">
            <img className="service-img" src={image} alt={text}/>
            <p onClick={onClick} className={"service-btn " + (isSelected? "service-btn-active": "")}>{text}</p>
        </div>
    )
}
export default Service
